import React, { FunctionComponent, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Grid, IconButton, Stack } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CenterFocusWeakIcon from '@mui/icons-material/CenterFocusWeak';
import CropIcon from '@mui/icons-material/Crop';
import { ImageDto } from '../../dto/LectionImageDto';
import {
  getImageVideoSize,
  getPageNumId,
  secureContent,
} from '../../utils/utils';
import { RESOURCE_URL } from '../../setting/AppSettings';
import { MyCheckBox } from '../UI/MyCheckBox';
import {
  IMAGE_TYPE_CROP,
  IMAGE_TYPE_ZOOM,
  IMAGE_TYPE_ZOOM_VIDEO,
  IMAGE_TYPE_ZOOM_WITH_BLACK,
} from '../../constant/constants';

interface Props {
  idPage: string;
  indexImage: number;
  imageType: number;
  zoomparam: number;
  dto: ImageDto;
  onCrop: (e: any) => any;
  onZoom: (e: any) => any;
  onClick: (e: any) => any;
  onUpdate: (e: any, e2: any, e3: any) => any;
}

export const WorksapceImageItemDiv: FunctionComponent<Props> = ({
  idPage,
  indexImage,
  imageType,
  zoomparam,
  dto,
  onCrop,
  onZoom,
  onClick,
  onUpdate,
}) => {
  const [value, setValue] = useState<ImageDto>(dto);
  const { section, route } = useParams();
  const page = getPageNumId(idPage);
  return (
    <Grid item xs={4}>
      <Stack width="100%" spacing={1}>
        <Card style={{ width: '100%' }}>
          <Stack width="100%" direction="column" spacing={1}>
            <Stack height={500} alignItems="center" justifyContent="center">
              {dto.name.includes('.png') && (
                <img
                  style={{
                    transform: `scale(${zoomparam})`,
                  }}
                  width={getImageVideoSize(dto, 330, 375)[0]}
                  height={getImageVideoSize(dto, 330, 375)[1]}
                  alt="not found"
                  src={`https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${route}&page=page_${page}&name=${
                    dto.name
                  }&${secureContent()}`}
                />
              )}
              {dto.name.includes('.mp4') && (
                <video width="90%" playsInline autoPlay muted loop>
                  <source
                    src={`https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${route}&page=page_${page}&name=${
                      dto.name
                    }&${secureContent()}`}
                    type="video/mp4"
                  />
                </video>
              )}
            </Stack>
            <Stack direction="row" width="100%" alignItems="center" spacing={1}>
              <IconButton size="medium" onClick={() => onClick(dto)}>
                <DeleteIcon
                  fontSize="medium"
                  sx={{
                    color: '#f44336',
                  }}
                />
              </IconButton>
              {imageType === IMAGE_TYPE_CROP && indexImage === 0 && (
                <IconButton size="medium" onClick={() => onCrop(dto)}>
                  <CropIcon
                    fontSize="medium"
                    sx={{
                      color: '#2196f3',
                    }}
                  />
                </IconButton>
              )}
              {(imageType === IMAGE_TYPE_ZOOM ||
                imageType === IMAGE_TYPE_ZOOM_WITH_BLACK ||
                imageType === IMAGE_TYPE_ZOOM_VIDEO) &&
                indexImage === 0 && (
                  <IconButton size="medium" onClick={() => onZoom(dto)}>
                    <CenterFocusWeakIcon
                      fontSize="medium"
                      sx={{
                        color: '#2196f3',
                      }}
                    />
                  </IconButton>
                )}
            </Stack>
          </Stack>
        </Card>
        <MyCheckBox
          value={value.fill === 1}
          onChange={(e) => {
            onUpdate('fill', e.target.checked ? 1 : 0, dto);
            setValue({
              ...value,
              fill: e.target.checked ? 1 : 0,
            });
          }}
          label="В оттенках серого"
        />
      </Stack>
    </Grid>
  );
};
